'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SliderInput = require('./SliderInput');

var _SliderInput2 = _interopRequireDefault(_SliderInput);

var _calculateGasSliderMax = require('../../../utilities/calculateGasSliderMax');

var _calculateGasSliderMax2 = _interopRequireDefault(_calculateGasSliderMax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GasSliderInput = function (_Component) {
  _inherits(GasSliderInput, _Component);

  function GasSliderInput(props, context) {
    _classCallCheck(this, GasSliderInput);

    var _this = _possibleConstructorReturn(this, (GasSliderInput.__proto__ || Object.getPrototypeOf(GasSliderInput)).call(this, props, context));

    _this.state = { hasDeviated: false };
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(GasSliderInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var recommendedGasPrice = _ref.recommendedGasPrice;
      var hasDeviated = this.state.hasDeviated;
      var _props = this.props,
          id = _props.id,
          onChange = _props.onChange,
          oldGasPrice = _props.recommendedGasPrice;

      // follow while not deviated

      if (!hasDeviated && recommendedGasPrice && recommendedGasPrice !== oldGasPrice) {
        onChange(id, recommendedGasPrice);
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(id, value) {
      var onChange = this.props.onChange;

      this.setState({ hasDeviated: true });
      onChange(id, value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          recommendedGasPrice = _props2.recommendedGasPrice,
          showHandleLabel = _props2.showHandleLabel,
          value = _props2.value,
          minLabel = _props2.minLabel,
          maxLabel = _props2.maxLabel;

      var labels = recommendedGasPrice ? _defineProperty({}, recommendedGasPrice, 'Recommended') : {};

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'span',
          { className: 'min-label' },
          minLabel
        ),
        _react2.default.createElement(_SliderInput2.default, _extends({}, this.props, {
          handleLabel: showHandleLabel ? value + ' Gwei' : '',
          onChange: this.handleChange,
          orientation: 'horizontal',
          labels: labels,
          step: 0.5,
          min: 1,
          max: (0, _calculateGasSliderMax2.default)(recommendedGasPrice),
          fieldSuffix: 'Gwei'
        })),
        _react2.default.createElement(
          'span',
          { className: 'max-label' },
          maxLabel
        )
      );
    }
  }]);

  return GasSliderInput;
}(_react.Component);

GasSliderInput.defaultProps = {
  recommendedGasPrice: null,
  showHandleLabel: false,
  minLabel: 'Cheap',
  maxLabel: 'Fast'
};


GasSliderInput.propTypes = {
  recommendedGasPrice: _propTypes2.default.number,
  id: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.number.isRequired,
  showHandleLabel: _propTypes2.default.bool,
  minLabel: _propTypes2.default.string,
  maxLabel: _propTypes2.default.string
};

GasSliderInput.displayName = 'GasSliderInput';

exports.default = GasSliderInput;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/form/elements/GasSliderInput.js
// module id = 1112
// module chunks = 0